import { gql } from "@/services/httpAdapter";

export const onUpdateTechnicianPerformance = gql`
	subscription onUpdateTechnicianPerformance($_id: String) {
		onUpdateTechnicianPerformance(_id: $_id) {
			_id
			locationId
			commissionCycleId
			payPeriodId
			isFinalized
		}
	}
`;

export const onUpdateTechnicianFlaggedTime = gql`
	subscription onUpdateTechnicianFlaggedTime($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onUpdateTechnicianFlaggedTime(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
		}
	}
`;
